// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SMK_","content":"styles_content__6AnDO","tableWrap":"styles_tableWrap__3HO2X"};